import Axios from "axios";

export class ProyectoServicioService {

    getLista(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/proyecto-servicio/lista?${queryParams}`).then(res => res.data);
    }

    nuevo(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/trust/proyecto-servicio/nuevo`, data).then(res => res.data);
    }

    editar(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/trust/proyecto-servicio/editar`, data).then(res => res.data);
    }

    consultar(id) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/proyecto-servicio/consulta/${id}`).then(res => res.data);
    }

    delete(id) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/trust/proyecto-servicio/eliminar/${id}`).then(res => res.data);
    }
}